export enum InvoiceType {
Item11,
Item12,
Item13,
Item14,
Item15,
Item16,
Item21,
Item22,
Item23,
Item24,
Item31,
Item32,
Item4,
Item51,
Item52,
Item61,
Item62,
Item71,
Item81,
Item82,
Item84,
Item85,
Item86,
Item111,
Item112,
Item113,
Item114,
Item115,
Item121,
Item131,
Item132,
Item133,
Item134,
Item1330,
Item1331,
Item141,
Item142,
Item143,
Item144,
Item145,
Item1430,
Item1431,
Item151,
Item161,
Item171,
Item172,
Item173,
Item174,
Item175,
Item176,
Item93,
}
